module.exports = __webpack_public_path__ + "static/media/gryphon-house-terraces.a6a2a3a0.jpeg";